import accountUtil from '../util/accountUtil'

const AccountPlugin = {
  install (Vue) {
    Vue.prototype.getAccount = () => accountUtil.getAccount()
    Vue.prototype.getAccountId = () => accountUtil.getAccountId()
  }
}

export default AccountPlugin
